// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  traceUntil as _traceUntil,
  traceWhile as _traceWhile,
  traceUntilComplete as _traceUntilComplete,
  traceUntilFirst as _traceUntilFirst
} from 'rxfire/performance';

export const traceUntil = ɵzoneWrap(_traceUntil, true);
export const traceWhile = ɵzoneWrap(_traceWhile, true);
export const traceUntilComplete = ɵzoneWrap(_traceUntilComplete, true);
export const traceUntilFirst = ɵzoneWrap(_traceUntilFirst, true);
